<template>
  <div class="header" id="header">
    <before-page-header v-if="isBeforeConnect" />
    <connect-header v-else />
  </div>
</template>

<script>
import beforePageHeader from "./before-page-header";
import connectHeader from "./connect-header";
export default {
  name: "page-header",
  components: { beforePageHeader, connectHeader },
  computed: {
    ...mapState({
      isBeforeConnect: state => state.isBeforeConnect
    })
  }
};
</script>

<style scoped lang="less">
.header {
  display: flex;
  height: 60px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  background-color: var(--header-bg);
  color: var(--header-title);
  width: 100%;
  top: 0;
  z-index: 75;
}
</style>
